import { GrapevineChatEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineChatEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineChatEventsApi(configuration),
    [configuration]
  );
};
